"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveAddressDetailsFromLatLng = exports.formatLocationAddressFromGooglePlace = void 0;
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const formatLocationAddressFromGooglePlace = (location) => {
    const { formatted_address, geometry: { location: { lat, lng } }, address_components } = location;
    const locationAddress = {
        fullAddress: formatted_address,
        country: "",
        streetAddress: "",
        suburb: "",
        state: "",
        postcode: "",
        lat: typeof lat === "function" ? lat() : lat,
        lng: typeof lng === "function" ? lng() : lng
    };
    address_components.forEach((addressComponent) => {
        const { short_name, long_name, types } = addressComponent;
        if (types.includes("subpremise")) {
            locationAddress.streetAddress += `${short_name}/`;
        }
        if (types.includes("street_number")) {
            locationAddress.streetAddress += `${short_name} `;
        }
        if (types.includes("route")) {
            locationAddress.streetAddress += `${short_name}`;
        }
        if (types.includes("locality")) {
            locationAddress.suburb += `${short_name}`;
        }
        if (types.includes("administrative_area_level_1")) {
            locationAddress.state += `${short_name}`;
        }
        if (types.includes("postal_code")) {
            locationAddress.postcode += `${short_name}`;
        }
        if (types.includes("country")) {
            locationAddress.country += `${long_name}`;
        }
    });
    return locationAddress;
};
exports.formatLocationAddressFromGooglePlace = formatLocationAddressFromGooglePlace;
const retrieveAddressDetailsFromLatLng = (googleApiKey) => async () => {
    const googleScript = document.getElementById("google");
    if (!googleScript) {
        const loader = new js_api_loader_1.Loader({
            apiKey: googleApiKey,
            version: "weekly"
        });
        await loader.load();
    }
    const successCallback = async (position) => {
        const { coords: { latitude, longitude } } = position;
        const geocoder = new google.maps.Geocoder();
        const latlng = {
            lat: latitude,
            lng: longitude
        };
        const { results } = await geocoder.geocode({ location: latlng });
        if (!Array.isArray(results) || results.length === 0) {
            return null;
        }
        const formattedLocationAddress = (0, exports.formatLocationAddressFromGooglePlace)(results[0]);
        return formattedLocationAddress;
    };
    const errorCallback = (error) => {
        throw new Error(error.message);
    };
    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    };
    return new Promise((resolve, reject) => 
    // both web and native implement same signature methods to get current location
    navigator.geolocation.getCurrentPosition(position => resolve(successCallback(position)), error => reject(errorCallback(error)), options));
};
exports.retrieveAddressDetailsFromLatLng = retrieveAddressDetailsFromLatLng;
//# sourceMappingURL=geoCode.js.map